export default __webpack_public_path__ + "img/a80984ee8b79cf381692caf04d7959c0.svg";